import { insuranceNetworkValues, } from "./InsuranceNetworks.js";
import { isTherapeuticMaterialCodeAllowed } from "./materiaux.js";
export const defaultImplantCrownMaterial = "PFMNP";
export function createEmptyDefaultMaterialsByActKind() {
    return {
        defaultByFamily: { implantCrown: defaultImplantCrownMaterial },
        networkOverrides: {},
    };
}
export function normalizeDefaultMaterialsByActKind(value) {
    if (!value) {
        return createEmptyDefaultMaterialsByActKind();
    }
    const networkOverrides = {};
    for (const network of insuranceNetworkValues) {
        const overrides = value.networkOverrides?.[network];
        if (!overrides) {
            continue;
        }
        networkOverrides[network] = { ...overrides };
    }
    return {
        // Existing preferences predate the dedicated implant-crown setting.
        defaultByFamily: {
            implantCrown: defaultImplantCrownMaterial,
            ...(value.defaultByFamily ?? {}),
        },
        networkOverrides,
    };
}
export function resolveDefaultMaterial({ settings, family, network, }) {
    const override = network
        ? settings.networkOverrides[network]?.[family]
        : undefined;
    // `null` explicitly disables the material for a network; only `undefined`
    // inherits the global default.
    const globalDefault = settings.defaultByFamily[family];
    const fallback = override === undefined
        ? globalDefault === undefined && family === "implantCrown"
            ? defaultImplantCrownMaterial
            : globalDefault ?? null
        : override;
    if (!fallback) {
        return null;
    }
    if (!network) {
        return fallback;
    }
    return isTherapeuticMaterialCodeAllowed({
        family,
        network,
        materialCode: fallback,
    })
        ? fallback
        : null;
}
//# sourceMappingURL=DefaultMaterialsByActKind.js.map